import React from "react";
import { Link } from "gatsby";

import logoB from "../../assets/image/logo_noksoft_2.png";
import logoW from "../../assets/image/logo_noksoft_2.png";

const Logo = ({ className = "", ...rest }) => {
  return (
    <Link to="/" className={`${className}`} {...rest}>
      {/* <!-- light version logo (logo must be black)--> */}
      <img src={logoB} alt="" className="light-version-logo" style={{ height:"50px" }} />
      {/* <!-- Dark version logo (logo must be White)--> */}
      <img src={logoW} alt="" className="dark-version-logo" style={{ height:"50px" }} />
    </Link>
  );
};

export default Logo;
